define([
	"csi/def/ActionFactory",
	"./_MoveUpDown"
], function(ActionFactory,_MoveUpDown) {

	return ActionFactory.declare("MoveUp", _MoveUpDown, {
		m_tag: "MoveUp",
		bUp: true
	});
});